import React, { useMemo } from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Button } from "@/components/Button/Button";
import DataTable from "@/components/Datatable/Datatable";
import { useStages } from "../../hooks/useStages";
import { createStageColumns } from "../StageColumns/StageColumns";
import StageFilters from "../StageFilters/StageFilters";
import CreateStageDrawer from "../CreateStageDrawer/CreateStageDrawer";
import EditStageDrawer from "../EditStageDrawer/EditStageDrawer";
import ViewStageDrawer from "../ViewStageDrawer/ViewStageDrawer";
import DeleteStageModal from "../DeleteStageModal/DeleteStageModal";

const StageList: React.FC = () => {
  const {
    stages,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    searchTerm,
    status,
    handlePaginationChange,
    handleSortingChange,
    handleSearchChange,
    handleStatusChange,
    loadingCreate,
    loadingUpdate,
    loadingDelete,
    isCreateOpen,
    openCreate,
    closeCreate,
    editingStage,
    openEdit,
    closeEdit,
    viewingStage,
    openView,
    closeView,
    editFromView,
    deleteTarget,
    requestDelete,
    closeDelete,
    submitCreate,
    submitEdit,
    confirmDelete,
  } = useStages();

  const columns = useMemo(
    () =>
      createStageColumns({
        onView: openView,
        onEdit: openEdit,
        onDelete: requestDelete,
      }),
    [openView, openEdit, requestDelete],
  );

  return (
    <>
      <MainPageWrapper
        actions={<Button onClick={openCreate}>Create Stage</Button>}
        error={error}
        title="Stages"
      >
        <StageFilters
          onSearchChange={handleSearchChange}
          onStatusChange={handleStatusChange}
          searchTerm={searchTerm}
          status={status}
        />

        <DataTable
          columns={columns}
          data={stages}
          error={error}
          loading={loading}
          noDataMessage="No stages found"
          onPageChange={(newPageIndex, newPageSize) =>
            handlePaginationChange({
              pageIndex: newPageIndex,
              pageSize: newPageSize,
            })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.uuid}
          sorting={sorting}
          totalCount={totalCount}
        />
      </MainPageWrapper>

      <CreateStageDrawer
        isOpen={isCreateOpen}
        loading={loadingCreate}
        onClose={closeCreate}
        onSubmit={submitCreate}
      />

      {editingStage && (
        <EditStageDrawer
          isOpen={!!editingStage}
          loading={loadingUpdate}
          onClose={closeEdit}
          onSubmit={submitEdit}
          stage={editingStage}
        />
      )}

      {viewingStage && (
        <ViewStageDrawer
          isOpen={!!viewingStage}
          onClose={closeView}
          onEdit={editFromView}
          stage={viewingStage}
        />
      )}

      <DeleteStageModal
        isOpen={!!deleteTarget}
        loading={loadingDelete}
        onClose={closeDelete}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default StageList;
